import { Component } from '@angular/core';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { RecalculateTransactionsFeatureComponent } from './recalculate-transactions-feature/recalculate-transactions-feature.component';

@Component({
    template: `<ui-view></ui-view>`,
    standalone: false
})
export class PeriodContainerComponent {}
export const PeriodRoute: Ng2StateDeclaration = {
    name: 'period',
    url: '/period',
    redirectTo: 'period.reprocessing',
    abstract: true,
    data: { requiresAuth: true },
    component: PeriodContainerComponent
};

export const RecalculateTransactionsRoute: Ng2StateDeclaration = {
    name: 'period.reprocessing',
    url: '/reprocessing',
    data: { requiresAuth: true },
    component: RecalculateTransactionsFeatureComponent
};
